import { create } from "zustand";

interface ScrollPosition {
  [pageKey: string]: number;
}

interface ScrollPositionState {
  positions: ScrollPosition;
  savePosition: (pageKey: string, position: number) => void;
  getPosition: (pageKey: string) => number;
  clearPosition: (pageKey: string) => void;
}

export const useScrollPositionStore = create<ScrollPositionState>((set, get) => ({
  positions: {},

  savePosition: (pageKey: string, position: number) => {
    set((state) => ({
      positions: {
        ...state.positions,
        [pageKey]: position,
      },
    }));
  },

  getPosition: (pageKey: string) => {
    return get().positions[pageKey] || 0;
  },

  clearPosition: (pageKey: string) => {
    set((state) => {
      const newPositions = { ...state.positions };
      delete newPositions[pageKey];
      return { positions: newPositions };
    });
  },
}));
